export const steps = [
    'Register',
    'Connect To Bank',
    'Select Round-Up Accounts',
    'Select Funding Account'
  ];